import { render, staticRenderFns } from "./Neighbourhood.vue?vue&type=template&id=3425b1e2&scoped=true"
import script from "./Neighbourhood.vue?vue&type=script&lang=js"
export * from "./Neighbourhood.vue?vue&type=script&lang=js"
import style0 from "./Neighbourhood.vue?vue&type=style&index=0&id=3425b1e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3425b1e2",
  null
  
)

export default component.exports